import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const Earnings = () => {
  const [earnings, setEarnings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  const [productsOptions, setProductsOptions] = useState([]);

  useEffect(() => {
    fetchData();
  }, [filters, sortField, sortOrder, currentPage]);

  const fetchData = async (page, itemsPerPage = 10, filters = {}) => {
    try {
      const token = localStorage.getItem("token");
      const filterParamsObj = {
        page: currentPage,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch earnings with filters, sorting, and pagination
      const { data: earnings, pagination } = await fetchDataFromAPI(
        `/api/earnings`,
        filterParams,
        token
      );
      const { data: products } = await fetchDataFromAPI(
        `/api/products`,
        {},
        token
      );
      console.log("earnings", earnings);
      console.log("products", products);

      // Update state
      setProductsOptions(products || []);
      setEarnings(earnings || []);
      setTotalPages(pagination?.totalPages || 1);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchData();
  };

  const handleSort = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchData();
  };

  const columns = [
    { header: "Order ID", accessor: "public_id", type: "showOnlyText" },
    { header: "Customer ID", accessor: "customer_id", type: "showOnlyText" },
    {
      header: "Products",
      accessor: "products",
      type: "showOnlyText",
    },
    { header: "Cost", accessor: "cost", type: "showOnlyRange" },
    { header: "Profit", accessor: "profit", type: "showOnlyRange" },
    {
      header: "Total Earnings",
      accessor: "total_earning",
      type: "showOnlyRange",
    },
    { header: "Earned At", accessor: "earning_date", type: "showOnlyDate" },
  ];

  return (
    <DataTable
      title="Earnings"
      columns={columns}
      data={earnings}
      currentPage={currentPage}
      totalPages={totalPages}
      onSort={handleSort}
      sortField={sortField}
      sortOrder={sortOrder}
      setData={setEarnings}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      apiEndpoint="/api/earnings"
      itemsPerPage={10}
      getRangeInputProps={getRangeInputProps}
      fetchData={fetchData}
    />
  );
};

export default Earnings;
